<template>
  <div class="position-relative">
    <div
      class="dropdown position-absolute"
      v-if="(comment.ownable.id === loggedInAs.id && !comment.by_admin) || loggedInAs.type === 'App\\User'"
      style="top: 0; right: 0"
    >
      <button
        class="btn btn-link btn-sm"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fas fa-ellipsis-h"></i>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          v-if="loggedInAs.type === 'App\\User'"
          class="dropdown-item"
          href="#"
          @click.prevent="setAsReview(comment, 10)"
        >
          {{ 'Make into review' | translate }}
          <span class="text-lowercase">({{ 'Positive' | translate }})</span>
        </a>
        <a
          v-if="loggedInAs.type === 'App\\User'"
          class="dropdown-item"
          href="#"
          @click.prevent="setAsReview(comment, 5)"
        >
          {{ 'Make into review' | translate }}
          <span class="text-lowercase">({{ 'Neutral' | translate }})</span>
        </a>
        <a
          v-if="loggedInAs.type === 'App\\User'"
          class="dropdown-item"
          href="#"
          @click.prevent="setAsReview(comment, 1)"
        >
          {{ 'Make into review' | translate }}
          <span class="text-lowercase">({{ 'Negative' | translate }})</span>
        </a>
        <div class="dropdown-divider" 
          v-if="loggedInAs.type === 'App\\User'"
        ></div>
        <a class="dropdown-item" href="#" @click.prevent="removeComment(comment)">
          {{ 'Delete' | translate }}
        </a>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-auto">
        <Avatar :user="student"></Avatar>
      </div>
      <div class="col">
        <div>
          <router-link
            class="fw-bold text-dark"
            :to="{
              name: 'students.show',
              params: { student: comment.ownable.id },
            }"
            v-if="loggedInAs.type === 'App\\User' && !comment.by_admin"
          >
            {{ author }}
          </router-link>
          <span v-else class="fw-bold">{{ author }}</span>
          <i v-if="comment.by_admin" class="fas fa-shield-alt"></i>
          <small class="text-muted">{{ time(comment.created_at) }}</small>
        </div>

        <div>
          <div class="mb-0" style="white-space: pre-wrap">{{ comment.body }}</div>
          <div v-if="comment.bunny_id" class="ratio ratio-16x9 mt-2">
            <div
              v-if="!comment.bunny_status || [0, 1, 2].includes(comment.bunny_status)"
              class="d-flex align-items-center justify-content-center border bg-secondary text-white"
            >
              <div>
                <div class="mb-3">
                  <Spinner></Spinner>
                </div>
                <div class="mx-5 text-center small">
                  {{
                    'This video is now transcoding. Please reload the page in few minutes to check if it has uploaded correctly.'
                      | translate
                  }}
                </div>
              </div>
            </div>

            <iframe
              :src="`https://player.mediadelivery.net/embed/25534/${comment.bunny_id}?autoplay=false&preload=false`"
              :key="comment.bunny_id"
              loading="lazy"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowfullscreen="true"
              v-else
            ></iframe>
          </div>
          <div class="d-flex">
            <Votes :votable="comment"></Votes>
            <div>
              <small class="me-2">
                <a class="text-uppercase text-dark" href="#" @click.prevent="toggleReplyCreate">
                  {{ 'Reply' | translate }}
                </a>
              </small>
            </div>
          </div>
        </div>
        <Replies ref="replies" :comment="comment"></Replies>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from '~/dayjs'
import Avatar from '~/player/components/Avatar'
import Replies from '~/player/components/Replies'
import ReplyCreate from '~/player/components/ReplyCreate'
import Votes from '~/player/components/Votes'
import Spinner from '~/app2/components/Spinner'
import _ from 'lodash'

export default {
  props: ['comment'],
  data() {
    return {
      replyCreate: false,
    }
  },
  components: {
    Avatar,
    Replies,
    ReplyCreate,
    Votes,
    Spinner,
  },
  computed: {
    loggedInAs() {
      return this.$store.state.user
    },
    student() {
      return this.comment.ownable
    },
    author() {
      return this.comment.ownable.name
    },
  },
  methods: {
    setAsReview(comment, score) {
      return this.$api.comments.setAsReview(comment.id, score).catch(this.handleErrors)
    },
    replyCreated(data) {
      let replies = _.get(this.comment, 'replies', [])
      this.$set(this.comment, 'replies', [...replies, data])
    },
    toggleReplyCreate() {
      this.$refs.replies.toggleReplyCreate()
    },
    time(date) {
      return dayjs(date).fromNow()
    },
    removeComment(comment) {
      let confirmed = confirm(this.$t('Are you sure?'))

      if (!confirmed) {
        return false
      }

      return this.$api.comments
        .delete(comment.id)
        .then(({ data }) => {
          this.$emit('commentRemoved', comment)
        })
        .catch(this.handleErrors)
    },
    handleErrors(error) {
      let status = _.get(error, 'response.status')
      if (status === 401) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Log in to set progress'),
        })
      } else if (status === 419) {
        iziToast.info({
          title: this.$t('Log in'),
          message: this.$t('Session expired'),
        })
      } else if (status === 422) {
        iziToast.error({
          title: 'Error',
          message: this.$t(_.get(error, 'response.data.errors.review[0]')),
          position: 'bottomLeft',
        })
      } else {
        console.error(error)
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'bottomLeft',
        })
      }
    },
  },
}
</script>

<style></style>
